export enum DesignSystem {
  Billy = 'billy',
  Lumen = 'lumen',
}
